export const slug = value => value.toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 75);